import request from '@/utils/request'
import gateway from '@/_gateway.config.js'

let { parent } = gateway

// 3. 获取referral信息
export function getRediract (params) {
  return request({
    url: `${parent}/api/order/self-service/link`, // `${parent}/api/wx/courseStage/detail?studentId=${parmas.studentId}&courseStageId=${parmas.courseStageId}`,
    method: 'get',
    params
  })
}
